import React, { useEffect } from 'react'
import './Soluciones.css'
import { useLocation } from "react-router-dom";
import Magnet from '../Magnet/Magnet'
import LazyVideo from '../LazyVideo/LazyVideo'


function Soluciones() {

    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const el = document.querySelector(location.hash);
            if (el) {
                setTimeout(() => {
                    el.scrollIntoView({ behavior: 'smooth' });
                }, 50);
            }
        }
    }, [location]);

    useEffect(() => {
        const els = document.querySelectorAll('.serv-card.reveal');
        const io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    io.unobserve(entry.target);
                }
            });
        }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
        els.forEach(el => io.observe(el));
        return () => io.disconnect();
    }, []);

    const items = [
        {
            num: '01',
            title: 'MEDICIÓN DEL TERRENO',
            desc: 'Realización de levantamientos topográficos de forma rápida y precisa en grandes superficies. A partir de imágenes aéreas georreferenciadas se generan ortomosaicos y modelos digitales del terreno que permitan analizar la morfología del área estudiada. Este tipo de servicio es especialmente útil en proyectos de ingeniería, agricultura, minería o planificación territorial.',
            media: { type: 'video', src: '/media/terreno.mp4' },
            span: 'span2'
        },
        {
            num: '02',
            title: 'MEDICIÓN VOLUMÉTRICA DE ACOPIOS',
            desc: 'Permite calcular con precisión el volumen de materiales almacenados en canteras, plantas de reciclaje, vertederos, explotaciones mineras o instalaciones industriales. Mediante técnicas de fotogrametría aérea, el dron captura imágenes que posteriormente se procesan para generar modelos tridimensionales del terreno y calcular con gran precisión el volumen de cada acopio.',
            media: { type: 'image', src: '/media/acopio.webp', alt: 'acopio' }
        },
        {
            num: '03',
            title: 'MODELOS 3D',
            desc: 'Permite recrear con gran precisión infraestructuras, edificaciones o terrenos completos en formato digital. A partir de cientos o miles de imágenes capturadas durante el vuelo, se procesan modelos 3D detallados que pueden utilizarse para análisis técnicos, planificación de proyectos, visualización avanzada o impresión 3D.',
            media: { type: 'image', src: '/media/modelo.webp', alt: 'modelos 3D' }
        },
        {
            num: '04',
            title: 'SEGUIMIENTO DE OBRA',
            desc: 'Documentación y análisis de la evolución de proyectos de construcción mediante capturas aéreas periódicas de alta resolución. Las imágenes obtenidas son procesadas para generar un mapa 2D que proporcione una visión global de la obra y permita comparar el avance real del proyecto con la planificación prevista además de llevar un registro del estado pasado.',
            media: { type: 'image', src: '/media/obras.webp', alt: 'seguimiento de obra' },
            span: 'span2'
        }
    ];

    return (
        <div className='degradado geo-section'>
            <div className='geo-pattern' />

            <div className="safety-stack">
                {items.map((item, i) => (
                    <article
                        key={item.num}
                        className={`serv-card reveal feat-card${i % 2 ? ' feat-card--rev' : ''}`}
                    >
                        <div className="serv-card__media">
                            {item.media.type === 'video' ? (
                                <LazyVideo src={item.media.src} className='serv-card__video' />
                            ) : (
                                <img src={item.media.src} alt={item.media.alt} loading="lazy" className='serv-card__img' />
                            )}
                        </div>
                        <div className="serv-card__body">
                            <span className="serv-card__num">{item.num} / 04</span>
                            <h3 className="serv-card__title">{item.title}</h3>
                            <p className="serv-card__desc">{item.desc}</p>
                        </div>
                    </article>
                ))}
            </div>

            <div className="espacio">
                <Magnet padding={30} disabled={false} magnetStrength={2} wrapperClassName='magneto' innerClassName='magnetoDos'>
                    <button onClick={() => window.location.href = "/#contacto"} className='cta'>
                        <span>CONTÁCTANOS</span>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                            <polyline points="12 5 19 12 12 19"></polyline>
                        </svg>
                    </button>
                </Magnet>
            </div>
        </div>
    )
}

export default Soluciones
